var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iso)?_c('span',{staticClass:"flag-icon",class:_vm.flagIconClass,attrs:{"title":_vm.title || _vm.iso}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }